/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { Locale } from '@/types/i18n';

export const localeCodes: Record<string, Locale> = {
  mx: 'es-MX',
  br: 'pt-BR',
  us: 'en-US',
};
